<div class="mat-app-background" style="width: 100%">
  <!-- Top Navigation -->
  @if (!isLoginPage) {
    <top-navbar [isSidenavOpen]="isExpanded" (sidenavToggleEvent)="getActionFromNavbar($event)" />
  }
  <mat-drawer-container
    [ngClass]="{ 'fullscreen-container-wo-header': isLoginPage, 'fullscreen-container-w-header': !isLoginPage }"
    class="mat-typography"
    autosize>
    <!-- Side Navigation -->
    @if (!isOnIntroPage && !isOnLegalPage && !!(isLoggedIn$ | async)) {
      <mat-drawer
        #soffSideNavigation
        mode="side"
        disableClose="false"
        opened="true"
        class="left-sidenav"
        [ngClass]="{ opened: !!(sideNavOpened$ | async) }">
        <mat-nav-list role="navigation">
          @for (sideNavigationItem of sideNavigationItems; track sideNavigationItem) {
            @if (
              accessGuard.isAccessOk(
                sideNavigationItem?.dsmLicenseNeeded,
                sideNavigationItem?.permissionNeeded,
                sideNavigationItem?.negatedPermission,
                sideNavigationItem.isProductionReady,
                sideNavigationItem.featureToggleNeeded
              ) | async
            ) {
              <mat-list-item
                class="nav-item"
                routerLink="{{ sideNavigationItem.routerLink }}"
                routerLinkActive="nav-item-active"
                [routerLinkActiveOptions]="{ exact: false }">
                <!-- Navigation closed-->
                @if ((sideNavOpened$ | async) !== true) {
                  <div>
                    <div style="display: flex; flex-direction: row; align-items: center">
                      <mat-icon [svgIcon]="'base:' + sideNavigationItem.icon"></mat-icon>
                    </div>
                  </div>
                } @else {
                  <div style="display: flex; flex-direction: row; align-items: center">
                    <mat-icon [svgIcon]="'base:' + sideNavigationItem.icon"></mat-icon>
                    <div style="margin-left: 8px">
                      {{ sideNavigationItem.labelI18nKey | translate }}
                    </div>
                  </div>
                }
                <!-- Navigation opened -->
              </mat-list-item>
            }
          }
          <mat-divider style="margin-top: 6px; margin-bottom: 6px" />

          <mat-list-item
            class="nav-item"
            (click)="showPrivacyBreadcrumb()"
            routerLink="/legal/privacy/web"
            routerLinkActive="nav-item-active"
            [routerLinkActiveOptions]="{ exact: false }">
            <!-- Navigation closed-->
            @if ((sideNavOpened$ | async) !== true) {
              <div>
                <div style="display: flex; flex-direction: row; align-items: center">
                  <img src="assets/icons/DSI.png" width="22" />
                </div>
              </div>
            } @else {
              <div style="display: flex; flex-direction: row; align-items: center">
                <img src="assets/icons/DSI.png" width="22" />
                <div style="margin-left: 8px">
                  {{ 'global.navigation.privacy' | translate }}
                </div>
              </div>
            }
            <!-- Navigation opened -->
          </mat-list-item>
          <mat-list-item
            class="nav-item"
            (click)="showTermsOfUseBreadcrumb()"
            routerLink="/legal/terms-of-use/web"
            routerLinkActive="nav-item-active"
            [routerLinkActiveOptions]="{ exact: false }">
            <!-- Navigation closed-->
            @if ((sideNavOpened$ | async) !== true) {
              <div>
                <div style="display: flex; flex-direction: row; align-items: center">
                  <img src="assets/icons/Legal.png" width="22" />
                </div>
              </div>
            } @else {
              <div style="display: flex; flex-direction: row; align-items: center">
                <img src="assets/icons/Legal.png" width="22" />
                <div style="margin-left: 8px">
                  {{ 'global.navigation.disclaimer' | translate }}
                </div>
              </div>
            }
            <!-- Navigation opened -->
          </mat-list-item>
          <mat-list-item class="nav-item" (click)="navigateToImprint()">
            <!-- Navigation closed-->
            @if ((sideNavOpened$ | async) !== true) {
              <div>
                <div style="display: flex; flex-direction: row; align-items: center">
                  <img src="/assets/icons/sidenav/paragraph.svg" width="25" />
                </div>
              </div>
            } @else {
              <div style="display: flex; flex-direction: row; align-items: center">
                <img src="/assets/icons/sidenav/paragraph.svg" width="25" />
                <div style="margin-left: 8px">
                  {{ 'global.navigation.imprint' | translate }}
                </div>
              </div>
            }
            <!-- Navigation opened -->
          </mat-list-item>
        </mat-nav-list>
        @if (!!(sideNavOpened$ | async)) {
          <div class="version-info">Service Office v{{ soffFEVersion }}</div>
        }
      </mat-drawer>
    }

    <!-- Page Content -->
    <mat-drawer-content>
      @if (breadCrumbData && !isOnIntroPage) {
        <cl-breadcrumb [breadCrumbData]="breadCrumbData"></cl-breadcrumb>
      }
      <!--
      @if (!bannerClosed && !!(isLoggedIn$ | async)) {
        <cl-banner [title]="'Important IT Maintenance'" [closeable]="true" (closeBanner)="closeBanner()">
          From Saturday, Sep 12, 2026, 5:00 PM to Sunday, Sep 13, 2026, 6:00 AM (CEST), we will be conducting extensive maintenance to enhance the
          performance, security, and reliability of our systems. Service Online will be unavailable during this period. Within Service Office, field
          service management, ticket and telemetry functionality will be available but certain functionality like claim history and apps like WebTIC,
          WebSI, Service Online, Lubricant Advisor, Inspection Pilot, Parts Doc ... will be unavailable. More details can be found in the referenced
          <a [href]="maintenanceInfoLink" target="_blank">PDF</a>, which is available in local languages. Thank you for your understanding.
        </cl-banner>
      }
-->
      <ng-container>
        <router-outlet></router-outlet>
      </ng-container>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
